import { Component } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

@Component({
  standalone: false,
  selector: 'app-cart-popup',
  templateUrl: './cart-popup.component.html',
  styleUrls: ['./cart-popup.component.css'],
  exportAs: 'cartPopup',
  animations: [
    trigger('cartState', [
      // Estado cerrado
      state('closed', style({
        opacity: 0,
        width: 0,
        right: '-1000px',
      })),
      // Estado abierto
      state('open', style({
        opacity: 1,
        width: '*',      // o un valor fijo, ej: '400px'
        right: 0,
      })),
      // Transiciones
      transition('closed => open', [
        animate('300ms ease-in')   // Duración y curva de animación
      ]),
      transition('open => closed', [
        animate('300ms ease-out')
      ])
    ])
  ]
})
export class CartPopupComponent {

  // Controla si está abierto o cerrado
  isOpen: boolean = false;

  constructor() { }

  // Abre
  openCart(): void {
    console.log("xasdasd");
    this.isOpen = true;
  }

  // Cierra
  closeCart(): void {
    this.isOpen = false;
  }

  toggleCart(): void {
    this.isOpen = !this.isOpen;
  }

  removeItem(itemId: number): void {
    console.log(`Eliminar item #${itemId}`);
  }

  viewCart(): void {
    console.log('Ir a la vista del carrito');
  }

  checkout(): void {
    console.log('Proceso de compra');
  }

}
